import { render, staticRenderFns } from "./SetupOverviewGroupSync.vue?vue&type=template&id=256b2e0b&scoped=true"
import script from "./SetupOverviewGroupSync.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewGroupSync.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverviewGroupSync.vue?vue&type=style&index=0&id=256b2e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b2e0b",
  null
  
)

export default component.exports